import { RelocationRecord } from "@/app/Relocations/GraphQL/relocationRecordQuery";
import { RelocationStatus } from "@/gql/graphql";
import { RelocationFormValues } from "./getDefaultRelocationValues";

export function getRelocationUpdateInput(
  relocation: RelocationRecord,
): RelocationFormValues {
  // Get all delivery office IDs from the group (excluding archived)
  const deliveryOfficeIds = [
    relocation.deliveryOffice.id,
    ...(relocation.group?.relocations
      .filter(
        (r) => r.id !== relocation.id && r.status !== RelocationStatus.Archived,
      )
      .map((r) => r.deliveryOffice.id) ?? []),
  ];

  return {
    supplier: {
      connect: relocation.supplier.id,
    },
    supplierInsuranceOption: {
      connect: relocation.supplierInsuranceOption?.id ?? null!,
    },
    vehicle: {
      connect: relocation.vehicle.id,
    },
    departureOffice: {
      connect: relocation.departureOffice.id,
    },
    deliveryOfficeIds,
    quantity: relocation.quantity ?? relocation.count,
    type: relocation.type,
    retail_rate: relocation.retail_rate,
    discount_percent: relocation.discount_percent,
    available_to_date: relocation.available_to_date,
    available_from_date: relocation.available_from_date,
    fixed_latest_departure_date: relocation.fixed_latest_departure_date,

    distance_allowed: relocation.distance_allowed,
    extra_distance_allowed_per_extra_hire_unit:
      relocation.extra_distance_allowed_per_extra_hire_unit,
    excess_distance_rate: relocation.excess_distance_rate,
    hire_unit_type: relocation.hire_unit_type,
    hire_units_allowed: relocation.hire_units_allowed,
    extra_hire_unit_deposit_rate: relocation.extra_hire_unit_deposit_rate ?? 0,
    extra_hire_unit_rate: relocation.extra_hire_unit_rate ?? 0,
    extra_hire_unit_supplier_net_rate:
      relocation.extra_hire_unit_supplier_net_rate,
    extra_hire_units_allowed: relocation.extra_hire_units_allowed,

    hire_unit_rate: relocation.hire_unit_rate,
    minimum_hire_units: relocation.minimum_hire_units,
    booking_fee_amount: relocation.booking_fee_amount,
    holding_deposit_amount: relocation.holding_deposit_amount,
    holding_deposit_refunded_at: relocation.holding_deposit_refunded_at,
    holding_deposit_refunded_by: relocation.holding_deposit_refunded_by,
    charge_per_move_amount: relocation.charge_per_move_amount,

    is_ferry_required: relocation.is_ferry_required,

    currency: relocation.currency,
    measurement: relocation.measurement,

    inclusions: {
      upsert: relocation.inclusions.map((inclusion) => {
        return {
          id: inclusion.id,
          type: inclusion.type,
          description: inclusion.description || null,
          has_free_tank: inclusion.has_free_tank,
          value: inclusion.value,
        };
      }),
      delete: [],
    },

    acknowledgements: {
      upsert: relocation.acknowledgements.map((ack) => ({
        id: ack.id,
        name: ack.name,
        acknowledgement: ack.acknowledgement,
      })),
      delete: [],
    },

    lines: {
      upsert: relocation.lines.map((ref) => ({
        id: ref.id,
        reference: ref.reference,
      })),
      delete: [],
    },
  };
}
